// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-card {
    max-width: 600px;
    margin: auto;
    width: 95%;
    padding: 10px;
    margin-top: 10px;

}

p {
    margin-left: 16px;
}

.custom-button-nazaj {
    background-color: orange;
    color: white;
}

.mat-card-actions {
    margin-left: 16px;
}

`, "",{"version":3,"sources":["webpack://./src/app/aplikacija/aplikacija-home-document/aplikacija-home-document.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,gBAAgB;;AAEpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".documents-card {\n    max-width: 600px;\n    margin: auto;\n    width: 95%;\n    padding: 10px;\n    margin-top: 10px;\n\n}\n\np {\n    margin-left: 16px;\n}\n\n.custom-button-nazaj {\n    background-color: orange;\n    color: white;\n}\n\n.mat-card-actions {\n    margin-left: 16px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
